var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BrowserHttpClient } from '@attraqt/http-client-browser';
import { Activity as ActivityGeneric } from '../activity';
var ActivityBrowser = /** @class */ (function (_super) {
    __extends(ActivityBrowser, _super);
    function ActivityBrowser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActivityBrowser.prototype.init = function (options, httpClient) {
        if (httpClient === void 0) { httpClient = new BrowserHttpClient(window); }
        if (!options.storage)
            options.storage = window.localStorage;
        _super.prototype.init.call(this, options, httpClient);
    };
    ActivityBrowser.prototype.send = function (activities, options) {
        if (navigator.doNotTrack === '1') {
            return null;
        }
        return _super.prototype.send.call(this, activities, options);
    };
    ActivityBrowser.prototype.sendAndStoreClusters = function (activities, options) {
        if (navigator.doNotTrack === '1') {
            return null;
        }
        return _super.prototype.sendAndStoreClusters.call(this, activities, options);
    };
    ActivityBrowser.prototype.handleQueuedEvents = function () {
        var _this = this;
        []
            .concat(window._attraqt)
            .filter(function (x) { return Array.isArray(x); })
            .forEach(function (element) {
            var _a;
            (_a = _this)[element[0]].apply(_a, element.filter(function (attr) { return attr; }).slice(1));
        });
        window._attraqt = [];
    };
    return ActivityBrowser;
}(ActivityGeneric));
// tslint:disable-next-line:variable-name
export var Activity = ActivityBrowser;
export var activity = new ActivityBrowser();
export var init = function (options) {
    activity.init(options.activity);
};
activity.handleQueuedEvents();
//# sourceMappingURL=browser.js.map